import React, { MutableRefObject } from 'react';
import { Send } from '@mui/icons-material';
import { IconButton, Row, TextArea } from 'library/ui';

interface Props {
    setMessageToSend: (s: string) => void;
    messageToSend: string;
    sendMessage: () => void;
    isSendingMessage: boolean;
    messagesEndRef: MutableRefObject<HTMLDivElement | null>;
}

export default function MessageInput({
    setMessageToSend,
    messageToSend,
    sendMessage,
    isSendingMessage,
    messagesEndRef,
}: Props) {
    const canSend = !isSendingMessage && !!messageToSend.trim();

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSend) sendMessage();
        }
    };

    return (
        <Row gap="sm" align="end" fullWidth>
            <TextArea
                placeholder="Message"
                value={messageToSend}
                onChange={(value) => {
                    setMessageToSend(value);
                    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }}
                onKeyDown={handleKeyDown}
                fullWidth
                minRows={1}
                resize={false}
            />
            <IconButton variant="filled" icon={Send} iconSize={20} onClick={sendMessage} disabled={!canSend} />
        </Row>
    );
}
